import { E2E_LANGUAGE_STORAGE_KEY } from '@/constant/common';

let language;


const nav_lang = (navigator.language || navigator.userLanguage || navigator.browserLanguage).toLowerCase();

// localstorage 存在 使用 localstorage 中设置的国际化
if (localStorage.getItem(E2E_LANGUAGE_STORAGE_KEY)) {
  language = localStorage.getItem(E2E_LANGUAGE_STORAGE_KEY);
} else {
  if (nav_lang.indexOf('zh') > -1) {
    language = 'zh';
  } else {
    language = 'en';
  }
}
// 924 设置语言为英文版本
// language = 'en';
localStorage.setItem(E2E_LANGUAGE_STORAGE_KEY, language);

export default language;



// WEBPACK FOOTER //
// ./src/util/language.js